import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, ActivityIndicator } from 'react-native';

import Colors from '../../constants/Colors';

import { AppText } from '../AppText';

// had to play with margin bottom to get map to show ok
const styles = StyleSheet.create({
  view: {
    backgroundColor: Colors.white,
    flex: 1,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    height: 50,
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
    alignItems: 'center',
  },
  headerText: {
    width: '50%',
    textTransform: 'uppercase',
    textAlign: 'center',
    color: Colors.mediumGray,
  },
  spinnerContainer: {
    flex: 1,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

class PantrySpinner extends Component {
  static propTypes = {
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    showHeader: PropTypes.bool.isRequired,
  };

  render() {
    const { translation, showHeader } = this.props;
    // get language labels
    const labels = {
      map: translation.fragment_main_tabitem_pantrymap,
      list: translation.fragment_main_tabitem_pantrylist,
    };

    return (
      <View style={styles.view}>
        {showHeader ? (
          <View style={styles.header}>
            <AppText style={styles.headerText}>{labels.map}</AppText>
            <AppText style={styles.headerText}>{labels.list}</AppText>
          </View>
        ) : null}
        <View style={styles.spinnerContainer}>
          <ActivityIndicator size="large" color={Colors.primaryColor} />
        </View>
      </View>
    );
  }
}

export default PantrySpinner;
